import SideTool from "@/global/components/side-tool";
import './index.less';
import { Table, Tooltip } from "antd";
import { DownloadFile, DownloadState, EditableCell, EditableRow, FileUploadParam, UploadFileLocale } from "tncet-common";
import { useContext, useEffect, useRef, useState } from "react";
import classnames from "classnames";
import { useParams } from "react-router-dom";
import { DownloadContext, UploadFileContext } from "@/App";
import TnMessage from "@/global/components/message";
import dayjs from "dayjs";
import { ProjectFile } from "@/global/interface/project-manage/project-file";
import { deleteProjectFile, findProjectFiles, uploadProjectFile } from "@/api/project-manage/project-file";

export default function FileManager() {
    const { projectId } = useParams();
    const uploadRef = useRef(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [activeRow, setActiveRow] = useState<ProjectFile>(null);
    const [projectFiles, setProjectFiles] = useState<ProjectFile[]>([]);
    const uploadFileContext = useContext(UploadFileContext);
    const downloadContext = useContext<DownloadState>(DownloadContext);
    const [uploadFileList, setUploadFileList] = useState([]);

    useEffect(() => {
        if (!projectId) return;
        generateData();
    }, [projectId])

    const generateData = () => {
        findProjectFiles(+projectId).then(res => {
            let data: ProjectFile[] = res.data || [];
            setProjectFiles(data);
        })
    }

    const onUploadClick = () => {
        if (uploadRef.current) {
            uploadRef.current.click();
        }
    }

    const onDownloadClick = () => {
        if (!activeRow) {
            TnMessage.info("未选中文件");
            return;
        }
        let downloadList = [];
        let dfile: DownloadFile = {
            filename: activeRow.name,
            suffix: activeRow.suffix,
            objectName: activeRow.filePath,
            bucketName: activeRow.bucketName
        }
        downloadList.push(dfile);
        downloadContext.startDownload(downloadList);

    }

    const onDeleteClick = () => {
        if (!activeRow) {
            TnMessage.info("未选中文件");
            return;
        }

        setLoading(true);
        deleteProjectFile(activeRow.id).then(res => {
            if (res.status === 200) {
                let newProjectFiles = projectFiles?.filter(item => item.id !== activeRow.id);
                setProjectFiles(newProjectFiles);
                setActiveRow(null);
                TnMessage.success("删除成功");
            }
        }).catch(err => {
            TnMessage.error("删除失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleFileChange = (e) => {
        const newFileList = Array.from(e.target.files);
        beforeUpload(null, newFileList);
    };

    const beforeUpload = (file, fileList) => {
        if (uploadFileList.length === 0) {
            setUploadFileList([...fileList]);
        }
        return false;
    }

    useEffect(() => {
        if (!uploadFileContext.visible && uploadFileList.length > 0) {
            setUploadFileList([]);
        }
    }, [uploadFileContext.visible])

    useEffect(() => {
        if (uploadFileList.length === 0) return;
        let files: UploadFileLocale[] = uploadFileList.map(item => {
            return {
                file: item,
                callbackFn: uploadCallbackFn
            }
        })
        uploadFileContext.startUpload(files)
    }, [uploadFileList])

    const uploadCallbackFn = (uploadFile: FileUploadParam) => {
        return new Promise(resolve => {
            let data: ProjectFile = {
                ...uploadFile,
                projectId: +projectId,
            }
            setLoading(true);
            uploadProjectFile(data).then(res => {
                if (res.status === 200) {
                    TnMessage.success("上传成功");
                    let newFile: ProjectFile = res.data;
                    setProjectFiles([...projectFiles, newFile])
                    resolve(true);
                }
            }).catch(err => {
                TnMessage.error("err", err);
            }).finally(() => {
                setLoading(false);
            })
        })
    }


    return (
        <div className="file-main">
            <SideTool
                onUploadClick={onUploadClick}
                onDownloadClick={onDownloadClick}
                onDeleteClick={onDeleteClick}
            />

            <div className="table-area">
                <Table
                    rowKey="id"
                    pagination={false}
                    dataSource={projectFiles}
                    className='tn-monix-table'
                    rowClassName={row => classnames({
                        "monix-row-select": activeRow?.id === row.id
                    })}
                    bordered={false}
                    components={{
                        body: {
                            row: EditableRow,
                            cell: EditableCell,
                        }
                    }}
                    onRow={row => {
                        return {
                            onClick: () => {
                                setActiveRow(row);
                            },
                            onContextMenu: e => {

                            },
                            // onMouseEnter: () => setHoverRow(row),
                            // onMouseLeave: () => setHoverRow(null),
                        }
                    }}
                    sticky
                    loading={loading}
                >
                    <Table.Column dataIndex="name" title="名称" width='45%' ellipsis
                        render={(value) => {
                            return (
                                <Tooltip title={value} placement="bottom">
                                    <div className='cell'>{value}</div>
                                </Tooltip>
                            )
                        }}
                    />
                    <Table.Column dataIndex="suffix" title="格式" width='20%' ellipsis
                        render={(value) => {
                            return (
                                <Tooltip title={value} placement="bottom">
                                    <div className='cell' style={{ fontSize: 12, lineHeight: '16px', marginBottom: 4, color: "#626262" }}>{value}</div>
                                </Tooltip>
                            )
                        }}
                    />
                    <Table.Column dataIndex="gmtCreate" title="时间" width='35%' ellipsis
                        render={(value) => {
                            return (
                                <Tooltip title={dayjs(value).format("YYYY-MM-DD")} placement="bottom">
                                    <div className='cell' style={{ fontSize: 12, lineHeight: '16px', color: "#626262" }}>{dayjs(value).format("YYYY-MM-DD")}</div>
                                </Tooltip>
                            )
                        }}
                    />
                </Table>

                <input type="file" ref={uploadRef} style={{ display: "none" }} onChange={handleFileChange} multiple />
            </div>
        </div>
    )
}